import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { userService } from './../../services/userService';

const RouteWithLayout = props => {
  const { layout: Layout, component: Component,allowAnonymous, ...rest } = props;
  const isAuthenticated = userService.isAuthenticated();
  return (
    <Route
      {...rest}
      render={matchProps => (
        (allowAnonymous || isAuthenticated) ? 
        <Layout>
          <Component {...matchProps} />
        </Layout> 
        : <Redirect to='/sign-in' />
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default RouteWithLayout;
